import { OneTariff, TOUTariffPrice } from '@/type/stationType'
import { TARIFF_TYPE } from '@/utils/const'
import timeToNumber from '@/utils/timeToNumber'
import { useTranslation } from 'react-i18next'

const useValidator = () => {
  const { t } = useTranslation()

  return {
    // 数字小数
    validateNumbersOrDecimal(_: any, value: string) {
      const reg = /^\d+(\.\d+)?$/
      if (reg.test(value)) {
        return Promise.resolve()
      } else {
        return Promise.reject(t('common.onlyNumbersAndDecimal'))
      }
    },

    // 电价合法性校验
    validateTariffItem(_: any, value: OneTariff) {
      const reg = /^\d+(\.\d+)?$/
      if (!value.type) {
        return Promise.reject(t('site.typeNotEmpty'))
      }
      if (value.type === TARIFF_TYPE.FIXED) {
        if (value.price && value.price !== '' && reg.test(value.price as string)) {
          return Promise.resolve()
        } else {
          return Promise.reject(t('site.priceFormatIncorrect'))
        }
      } else {
        let flag = true
        ;(value.price as TOUTariffPrice[]).map((tariff) => {
          if (tariff.data.length === 0) {
            flag = false
            return
          }
          if (tariff.data[0].startTime !== '00:00' || tariff.data[tariff.data.length - 1].endTime !== '23:59') {
            flag = false
            return
          }
          tariff.data.map((item) => {
            if (
              !item.startTime ||
              item.startTime === '' ||
              !item.endTime ||
              item.endTime === '' ||
              !item.value ||
              item.value === '' ||
              !reg.test(item.value) ||
              timeToNumber(item.startTime) >= timeToNumber(item.endTime)
            ) {
              flag = false
            }
          })
        })
        if (flag) {
          return Promise.resolve()
        } else {
          return Promise.reject(t('site.tariffIllegal'))
        }
      }
    },
  }
}

export default useValidator
